import { useEffect, useState } from 'react';

import { useToastStore } from '@/store/apps/toastStore';

import { IconCheckRound, IconXmarkRound } from '@/components/apps/ui/icon';

import theme from '@/styles/theme';

import BadgeIcon from '../badge/BadgeIcon';
import ButtonIcon from '../buttons/ButtonIcon';
import type { ToastType } from './types';

type Props = {
  id: string;
  index: number;
  state: ToastType['state'];
  message: string;
  toastClose: () => void;
};

export default function Toast({
  id,
  index,
  state,
  message,
  toastClose,
}: Props) {
  const [isClosing, setIsClosing] = useState<boolean>(false);
  const { closeToast } = useToastStore();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsClosing(true);
      setTimeout(() => {
        closeToast(id);
      }, 300); // 애니메이션 시간(0.3초) 이후에 토스트를 닫음
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  }, [id, closeToast]);

  // index 는 원본에서도 주석 처리된 order 조정용으로만 쓰여 시각 효과가 없다.
  void index;

  return (
    <div
      className={`pointer-events-auto relative flex w-[335px] max-w-[calc(100%-30px)] cursor-default items-center justify-between gap-3 overflow-hidden rounded bg-apps-coreGrayBlack py-3 pl-5 pr-3 backdrop-blur-[1px] transition-opacity duration-300 ease-in-out ${
        isClosing ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="flex items-center gap-3">
        {state === 'positive' ? (
          <BadgeIcon
            size="md"
            color="success"
            icon={
              <IconCheckRound
                size={12}
                color={theme`colors.apps.coreGrayWhite`}
              />
            }
          />
        ) : (
          <BadgeIcon
            size="md"
            color="error"
            icon={
              <IconXmarkRound
                size={12}
                color={theme`colors.apps.coreGrayWhite`}
              />
            }
          />
        )}
        <div
          className="relative whitespace-pre-wrap text-sm font-medium leading-[140%] tracking-[-0.28px] text-apps-coreGrayWhite"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </div>
      <i className="cursor-pointer">
        <ButtonIcon onClick={toastClose} aria-label="알림 닫기">
          <IconXmarkRound size={16} color={theme`colors.apps.coreGrayWhite`} />
        </ButtonIcon>
      </i>
    </div>
  );
}
